import React from "react"
import Layout from "../components/layout"
import FrontPageContent from "../components/frontpagecontent"

export default function IndexPage() {
 return (
  <Layout>
    <div style={{ position: 'relative' }}>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <FrontPageContent/>
    </div>
    </div>
  </Layout>
 )
}
